mutation ApprovalFlowCopy($input: ApprovalCopyInput!) {
  approvalCopy(input: $input) {
    clientMutationId
    approval {
      id
      __typename
      _urgencyLevel
      description
      name
      badgeColor
      _fullApprovalDescription
      isAddApproversEligible
      isPrimary
      isNewApprovalSelectable
      isDelayedApproverAllowed
      _rowTimestamp
      _isDeletable
      _infoLines {
        infoLine1
        infoLine2
        infoLine3
        infoLine4
        isTested
        activeTestCount
      }
      approvalType {
        id
        approvalType
        layoutType
      }
      approvalPhaseTypeId
      approvalPhaseType {
        id
        phaseName
      }
      _createdDate
      priorityNumber
      abbreviation
      isDraft
      _statusTypeId
      statusType {
        approvalState
        statusType
        _transactionIconStatus
      }
      _isStagedApprovalRequest
    }
  }
}
